function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.31 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.4,5.75h-69A4.54,4.54,0,0,0,7,10.35V41.4a1.75,1.75,0,1,0,3.49,0v-31a1,1,0,0,1,1-1h69a1,1,0,0,1,1,1V79.84a1,1,0,0,1-1,1h-69a1,1,0,0,1-1-1V55.55A3.4,3.4,0,0,0,12,52.71a3.28,3.28,0,1,0-6.55,0A3.37,3.37,0,0,0,7,55.55V79.84a4.54,4.54,0,0,0,4.48,4.59h69a4.54,4.54,0,0,0,4.48-4.59V10.35A4.54,4.54,0,0,0,80.4,5.75Z",
    style: {
      fill: "#006098"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.71,38.13a8.65,8.65,0,0,1,.71-3.59,7.5,7.5,0,0,1,1.89-2.6,7.92,7.92,0,0,1,2.57-1.51,8.59,8.59,0,0,1,8.44,1.51,7.78,7.78,0,0,1,1.84,2.6,8.49,8.49,0,0,1,.71,3.59V55.9a8.41,8.41,0,0,1-.71,3.64A7.36,7.36,0,0,1,41.32,62,7.89,7.89,0,0,1,38.7,63.6a8.4,8.4,0,0,1-5.82,0A7.4,7.4,0,0,1,30.31,62a7.11,7.11,0,0,1-1.89-2.5,8.56,8.56,0,0,1-.71-3.64ZM32.53,55.9a3.21,3.21,0,0,0,1,2.58,3.61,3.61,0,0,0,4.58,0,3.21,3.21,0,0,0,1-2.58V38.13a3.21,3.21,0,0,0-1-2.58,3.61,3.61,0,0,0-4.58,0,3.21,3.21,0,0,0-1,2.58Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,30.19l-6.9,33.65H52.47L45.62,30.19h5.11l3.82,23.49h.1l3.87-23.49Z",
    style: {
      fill: "#0075c9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvIcon);
export default __webpack_public_path__ + "static/media/ovIcon.a3417842.svg";
export { ForwardRef as ReactComponent };